// src/services/certificacionService.js
import { apiClient } from './api';
import config from '../config.js';

const BASE_URL = config.API_BASE_URL;

export const certificacionService = {

  async iniciar(rutEmpresa, tipoOnboarding, tiposDteObjetivo, numerosAtencion = null) {
    return apiClient.post('/certificacion/iniciar', {
      rut_empresa: rutEmpresa,
      tipo_onboarding: tipoOnboarding,
      tipos_dte_objetivo: tiposDteObjetivo,
      numeros_atencion: numerosAtencion,
    });
  },

  async getEstado(rutEmpresa) {
    return apiClient.get(`/certificacion/${rutEmpresa}`);
  },

  async ejecutarPaso(rutEmpresa, pasoId) {
    return apiClient.post(`/certificacion/${rutEmpresa}/paso/${pasoId}/ejecutar`);
  },

  async completarPaso(rutEmpresa, pasoId, notas = null) {
    return apiClient.post(`/certificacion/${rutEmpresa}/paso/${pasoId}/completar`, { notas });
  },

  async reintentarPaso(rutEmpresa, pasoId, forzar = false) {
    const qs = forzar ? '?forzar=true' : '';
    return apiClient.post(`/certificacion/${rutEmpresa}/paso/${pasoId}/reintentar${qs}`);
  },

  async reenviarCasos(rutEmpresa, casoNums) {
    return apiClient.post(`/certificacion/${rutEmpresa}/reenviar-casos`, { caso_nums: casoNums.map(String) });
  },

  async getResultadoPaso(rutEmpresa, pasoId) {
    return apiClient.get(`/certificacion/${rutEmpresa}/paso/${pasoId}/resultado`);
  },

  async actualizarNotas(rutEmpresa, notas) {
    return apiClient.patch(`/certificacion/${rutEmpresa}/notas`, { notas });
  },

  async cargarSetPruebas(rutEmpresa, archivo) {
    const formData = new FormData();
    formData.append('archivo', archivo, archivo.name);
    return apiClient.uploadFile(`/certificacion/${rutEmpresa}/cargar-set`, formData);
  },

  async subirAdjunto(rutEmpresa, pasoId, archivo) {
    const formData = new FormData();
    formData.append('archivo', archivo, archivo.name);
    return apiClient.uploadFile(`/certificacion/${rutEmpresa}/paso/${pasoId}/adjunto`, formData);
  },

  async listarAdjuntos(rutEmpresa, pasoId) {
    return apiClient.get(`/certificacion/${rutEmpresa}/paso/${pasoId}/adjuntos`);
  },

  async eliminarAdjunto(adjuntoId) {
    return apiClient.delete(`/certificacion/adjunto/${adjuntoId}`);
  },

  getUrlDescarga(adjuntoId) {
    return `${BASE_URL}/certificacion/adjunto/${adjuntoId}/descargar`;
  },

  async previewPaso(rutEmpresa, pasoId) {
    return apiClient.get(`/certificacion/${rutEmpresa}/paso/${pasoId}/preview`);
  },

  async consultarTrackid(rutEmpresa, trackid, casoNum) {
    return apiClient.post(`/certificacion/${rutEmpresa}/consultar-trackid`, {
      trackid: String(trackid),
      caso_num: String(casoNum),
    });
  },

  async ejecutarSimulacion(rutEmpresa, documentos) {
    return apiClient.post(`/certificacion/${rutEmpresa}/simulacion/ejecutar`, { documentos });
  },

  async listarDocumentosEmitidos(rutEmpresa) {
    return apiClient.get(`/certificacion/${rutEmpresa}/documentos-emitidos`);
  },

  async listarEmitidosSimulacion(rutEmpresa) {
    return apiClient.get(`/certificacion/${rutEmpresa}/simulacion/emitidos`);
  },
};

export const TIPOS_DTE_CERTIFICACION = [
  { codigo: 33, nombre: 'Factura Electrónica' },
  { codigo: 39, nombre: 'Boleta Electrónica' },
  { codigo: 52, nombre: 'Guía de Despacho' },
  { codigo: 56, nombre: 'Nota de Débito' },
  { codigo: 61, nombre: 'Nota de Crédito' },
];

export const TIPOS_ONBOARDING = [
  { value: 'nueva',   label: 'Nueva — Primera certificación' },
  { value: 'migrada', label: 'Migrada — Ya es emisor electrónico' },
  { value: 'parcial', label: 'Parcial — Agregar tipo DTE' },
];
